import { TableCell as TCell, TableRow as TRow } from '../../Table';
import { TableDefaultEmptyState } from "./TableDefaultEmptyState";
import { EmptyStateConfigProps } from '../types';

interface TableEmptyStateProps {
    columnsLength: number;
    emptyStateConfig: EmptyStateConfigProps;
}

export function TableEmptyState({ columnsLength, emptyStateConfig }: TableEmptyStateProps) {
    const defaultEmptyState = (
        <div className="absolute inset-0 flex items-center justify-center">
            <TableDefaultEmptyState {...emptyStateConfig} />
        </div>
    );

    return (
        <TRow className="relative">
            <TCell colSpan={columnsLength} className="h-[300px] p-0 relative">
                <div className="absolute inset-0 w-full">
                    {emptyStateConfig.renderEmptyState?.() || defaultEmptyState}
                </div>
            </TCell>
        </TRow>
    );
}